<template>
  <section class="page-dashbord-sections my-5">
    <app-loading :isFull="true" v-if="isLoading" />
    <div class="progress-up" v-if="uploadPercentage > 0 && uploadPercentage !==  100">
      <div class="parent-loading">
        <b-progress
          show-progress
          animated
          :value="uploadPercentage"
          class="mt-2 w-100"
          :variant="'info'"
        ></b-progress>
      </div>
    </div>
    <div class="progress-up" v-if="uploadPercentageData > 0 && uploadPercentageData !==  100">
      <div class="parent-loading">
        <b-progress
          show-progress
          animated
          :value="uploadPercentageData"
          class="mt-2 w-100"
          :variant="'info'"
        ></b-progress>
      </div>
    </div>

    <div class="container">
      <div class="row">
        <div class="col-12">
          <header class="text-right mb-4">
            <h1 class="font-20">فصل ها</h1>
          </header>
        </div>
      </div>
      <span
        class="wrapper-section-forms"
        v-for="(section,index) in forms"
        :key="index"
        v-if="forms.length"
      >
        <div class="card-header rtl text-right" v-b-toggle="'div'+index">
          <toggle-open />
          فصل {{section.section_num}}
        </div>
        <b-collapse
          :id="'div'+index"
          accordion="my-accordion"
          @hidden="clearLects(section,index)"
          @show="showLects(section,index)"
          :visible="index === expanded"
        >
          <form class="wrapper-form shadow p-4 mb-5" 
              @submit.prevent
              :data-vv-scope="`form-section-${section.section_num}`"
          >
            <div class="row">
              <div class="col-6">
                <div class="group-form">
                  <input
                    maxlength="60"
                    type="text"
                    v-validate="'required'"
                    name="section_name"
                    :class="{active:section.section_name != '' }"
                    v-model="section.section_name"
                  />
                  <span class="bar"></span>
                  <label class="statr">نام فصل</label>
                  <span v-if="errors.has(`form-section-${section.section_num}.section_name`)" class="is-danger">فیلد نباید خالی باشد</span>
                </div>
              </div>
              <div class="col-6">
                <div class="d-flex justify-content-end">
                  <div v-if="section.id || section.section_id">
                    <button
                      @click="removeSection(section,index)"
                      class="mt-1 bttn-material-circle bttn-md bttn-danger flaticon-dustbin"
                      v-ripple
                      :title="'حذف فصل'"
                    ></button>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="group-form">
                  <textarea
                    type="text"
                    maxlength="250"
                    v-validate="'required'"
                    name="section_description"
                    :class="{active:section.section_description != '' }"
                    v-model="section.section_description"
                  ></textarea>
                  <span class="bar"></span>
                  <label class="statr">توضیحات فصل</label>
                  <span
                    v-if="errors.has(`form-section-${section.section_num}.section_description`)"
                    class="is-danger"
                  >فیلد نباید خالی باشد</span>
                </div>
              </div>
              <div class="col-8">
                <!-- <div class="group-form">
                                    <input type="text" v-validate="'required'" name="price" :class="{active:section.price != '' || section.price == 0 }" v-model="section.price">
                                    <span class="bar"></span>
                                    <label class='statr'>قیمت</label>
                                    <span v-if="errors.has('price')" class="is-danger">فیلد نباید خالی باشد</span>
                </div>-->
              </div>
              <div class="col-4">
                <div class="form-action mt-2">
                  <button
                    v-if="!section.section_id"
                    class="font-16 px-5 py-2 bttn-fill bttn bttn-success"
                    v-ripple
                    @click="saveSection(section,index,`form-section-${section.section_num}`)"
                  >ذخیر فصل</button>
                  <button
                    v-else
                    class="font-16 px-5 py-2 bttn-fill bttn bttn-success"
                    v-ripple
                    @click="updateSection(section,index,`form-section-${section.section_num}`)"
                  >بروزرسانی فصل</button>
                </div>
              </div>
            </div>
          </form>
          <div v-for="(lecture,i) in section.lectures" :key="i">
            <div class="row">
              <div class="col-12">
                <header class="text-right mb-4">
                  <h2 class="font-18">قسمت {{lecture.lecture_num}}</h2>
                </header>
              </div>
            </div>
            <form
              class="wrapper-form mb-3 shadow p-4"
              @submit.prevent
              :data-vv-scope="`form-${section.section_name}-${lecture.lecture_num}`"
            >
              <div class="row">
                <div class="col-6">
                  <div class="group-form">
                    <input
                      maxlength="255"
                      type="text"
                      v-validate="'required'"
                      name="lecture_name"
                      :class="{active:lecture.lecture_name != '' }"
                      v-model="lecture.lecture_name"
                    />
                    <span class="bar"></span>
                    <label class="statr">نام قسمت</label>
                    <span
                      v-if="errors.has(`form-${section.section_name}-${lecture.lecture_num}.lecture_name`)"
                      class="is-danger"
                    >فیلد نباید خالی باشد</span>
                  </div>
                </div>
                <div class="col-6">
                  <div class="d-flex justify-content-end">
                    <div class="ml-1" v-if="lecture.id">
                      <button
                        @click="getPlaye(section,index,lecture,i)"
                        class="mt-1 bttn-material-circle bttn-md bttn-royal flaticon-play-1"
                        v-ripple
                        :title="'نمایش ویدئو'"
                      ></button>
                    </div>
                    <div v-if="lecture.id">
                      <button
                        @click="removeLecture(section,index,lecture,i)"
                        class="mt-1 bttn-material-circle bttn-md bttn-danger flaticon-dustbin"
                        v-ripple
                        :title="'حذف قسمت'"
                      ></button>
                    </div>
                  </div>
                </div>

                <div class="col-12">
                  <div class="group-form">
                    <textarea
                      maxlength="250"
                      type="text"
                      name="lecture_description"
                      :class="{active:lecture.lecture_description != '' }"
                      v-model="lecture.lecture_description"
                    ></textarea>
                    <span class="bar"></span>
                    <label class="statr">توضیحات قسمت</label>
                  </div>
                </div>
                <div class="col-12 clearfix my-3">
                  <div class="input-group mb-3" v-if="!lecture.id">
                    <div class="custom-file">
                      <input
                        type="file"
                        v-validate="'required'"
                        accept="video/*"
                        class="custom-file-input"
                        id="lecture_video"
                        name="lecture_video"
                        @change="uploadVideo($event,section,index,lecture,i)"
                      />
                      <label
                        class="custom-file-label"
                        for="lecture_video"
                      >{{lecture.lecture_video ? lecture.lecture_video.name : 'آپلود فایل'}}</label>
                    </div>
                    <div class="input-group-prepend">
                      <span class="input-group-text">آپلود ویدئو</span>
                    </div>
                  </div>
                  <div class="group-form">
                    <span
                      v-if="errors.has(`form-${section.section_name}-${lecture.lecture_num}.lecture_video`)"
                      class="is-danger"
                    >ارسال ویدئو الزامیست</span>
                  </div>

                  <!-- <div class="group-form">
                    <span v-if="errors.has('lecture_video')" class="is-danger">فیلد نباید خالی باشد</span>
                  </div>-->
                </div>
                <div class="col-12 clearfix my-3">
                  <div class="input-group mb-3" v-if="lecture.id">
                    <div class="custom-file">
                      <input
                        type="file"
                        accept="video/*"
                        class="custom-file-input"
                        id="lecture_video"
                        name="lecture_video"
                        @change="updateVideo($event,section,index,lecture,i)"
                      />
                      <label
                        class="custom-file-label"
                        for="lecture_video"
                      >{{lecture.lecture_video ? lecture.lecture_video.name : 'آپلود فایل'}}</label>
                    </div>
                    <div class="input-group-prepend">
                      <span class="input-group-text">بروزرسانی ویدئو</span>
                    </div>
                  </div>
                </div>
                <!-- <div class="col-6">
                                    <div class="input-checkbox rtl text-right">
                                        <div class="md-checkbox">
                                            <input type="checkbox" :id="'has_exam'+i" v-model="lecture.has_exam">
                                            <label :for="'has_exam'+i" class="font-14">امتحان دارد</label>
                                        </div>
                                    </div>
                </div>-->
                <div class="col-12" v-if="lecture.id">
                  <p class="text-info pointer" @click="downloadVideo(lecture,i)">
                    <i class="flaticon-file icon-22"></i>
                    دانلود ویدئو
                  </p>
                </div>
                <div class="col-6">
                  <div class="input-checkbox rtl text-right">
                    <div class="md-checkbox">
                      <input
                        type="checkbox"
                        :disabled="index == 0 && i == 0"
                        :id="'is_preview'+i"
                        v-model="lecture.is_preview"
                      />
                      <label :for="'is_preview'+i" class="font-14">نمایش رایگان</label>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="input-checkbox rtl text-right">
                    <div class="md-checkbox">
                      <input type="checkbox" :id="'has_file'+i" v-model="lecture.has_file" />
                      <label
                        :for="'has_file'+i"
                        class="font-14"
                      >این قسمت دارای فایل آموزشی/امتحانی/نرم افزار است</label>
                    </div>
                  </div>
                </div>
                <div class="col-11 clearfix my-3">
                  <div class="input-group mb-3" v-if="lecture.has_file">
                    <div class="custom-file">
                      <input
                        type="file"
                        accept=".zip, .pdf, .odt, .docx, .doc, .ppt, .pptx"
                        v-if="!lecture.linkFile"
                        class="custom-file-input"
                        :name="index+'attachedFile'+i"
                        @change="uploadFile($event,section,index,lecture,i)"
                      />
                      <input
                        type="file"
                        accept=".zip, .pdf, .odt, .docx, .doc, .ppt, .pptx"
                        v-if="lecture.linkFile"
                        class="custom-file-input"
                        :name="index+'attachedFile'+i"
                        @change="updateFile($event,section,index,lecture,i)"
                      />
                      <label
                        class="custom-file-label"
                        for="attachedFile"
                        v-if="!lecture.linkFile"
                      >{{lecture.attachedFile ? lecture.attachedFile.name : 'آپلود فایل'}}</label>
                      <label
                        class="custom-file-label"
                        for="attachedFile"
                        v-else
                      >{{lecture.attachedFile.attachedFile , 50 | truncate}}</label>
                    </div>
                    <div class="input-group-prepend">
                      <span class="input-group-text">آپلود فایل</span>
                    </div>
                  </div>
                  <div
                    class="d-flex flex-row justify-content-start font-14"
                    v-if="lecture.has_file"
                  >
                    <span class="ml-3">حجم فایل مجاز : 200 MB</span>
                    <span>فرمت های مجاز : .zip,.pdf,.odt,.docx,.doc,.ppt,.pptx</span>
                  </div>
                </div>
                <div class="col-1 px-0 pt-4 text-right" v-if="lecture.has_file && lecture.linkFile">
                  <a
                    @click.prevent="downloadFile(section,index,lecture,i)"
                    class="font-14 pointer text-info w-100"
                  >لینک فایل</a>
                </div>
                <div class="col-12">
                  <div class="text-left form-action mt-2">
                    <button
                      v-if="!lecture.id"
                      class="font-16 px-5 py-2 bttn-fill bttn bttn-success"
                      v-ripple
                      @click="savePart(section,index,lecture,i,`form-${section.section_name}-${lecture.lecture_num}`)"
                    >ذخیره قسمت</button>
                    <button
                      v-if="lecture.id"
                      class="font-16 px-5 py-2 bttn-fill bttn bttn-success"
                      v-ripple
                      @click="updatePart(section,index,lecture,i,`form-${section.section_name}-${lecture.lecture_num}`)"
                    >ثبت ویرایش</button>
                  </div>
                </div>
              </div>
            </form>
            <!-- newPart -->
            <div class="col-12">
              <div
                class="form-action m-5"
                v-if="(section.lectures && section.lectures.length && section.lectures.slice(-1)[0].id) || (section && (section.id || section.section_id))"
              >
                <button
                  v-if="section.lectures.slice(-1)[0].id === lecture.id"
                  class="font-16 px-5 py-2 bttn-jelly bttn btn-block rounded bttn-primary"
                  v-ripple
                  @click="newPart(section,index,lecture,i)"
                >
                  <i class="mdi mdi-plus"></i>
                  ایجاد قسمت جدید
                </button>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="form-action m-5">
              <div v-if="!section.lectures || !section.lectures.length">
                <button
                  v-if="(section.lectures && section.lectures.length && section.lectures.slice(-1)[0].id) || (section && (section.id || section.section_id))"
                  class="font-16 px-5 py-2 bttn-jelly bttn btn-block rounded bttn-primary"
                  v-ripple
                  @click="partOne(section,index)"
                >
                  <i class="mdi mdi-plus"></i>
                  ساخت اولین قسمت
                </button>
              </div>
            </div>
          </div>
        </b-collapse>
      </span>
      <div class="col-12 mt-4">
        <div class="form-action text-left">
          <button
            class="font-16 px-5 py-2 bttn-jelly bttn btn-block rounded bttn-success"
            v-ripple
            @click="addSections"
          >
            <i class="mdi mdi-plus"></i>
            ایجاد فصل جدید
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <controller-curose>
            <button
              class="font-16 px-5 py-2 bttn-jelly bttn rounded bttn-primary"
              v-ripple
              @click="nextStep"
            >
              <!-- <i class="mdi mdi-plus"></i> -->
              رفتن به مرحله ی بعد
            </button>
          </controller-curose>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import toggleOpen from "cp/min-component/open-colose.vue";
var vm;
export default {
  name: "page-dashbord-sections",
  computed: {
    uploadPercentage() {
      return this.$store.state.dashboardSections.uploadPercentage;
    }
  },
  components: {
    toggleOpen
  },
  data() {
    return {
      uploadPercentageData: 0,
      expanded: -1,
      active: false,
      isLoading: true,
      bodyFile: [],
      forms: [],
      isAdd: false,
      sectionInform: {
        section_name: "",
        section_description: "",
        price: 0,
        section_num: 0,
        section_id: null,
        course: parseInt(this.hasCourse().id),
        lectures: []
      },
      lectureForm: {
        lecture_name: "",
        lecture_description: "",
        has_exam: false,
        has_file: false,
        is_preview: false,
        lecture_video: "",
        lecture_num: 0,
        course: parseInt(this.hasCourse().id),
        section_id: null,
        attachedFile: null,
        linkFile: null
      }
    };
  },
  mounted() {
    vm = this;
    if (localStorage && !this.hasCourse().id) {
      this.$root.showWarnMsg({
        message: "شما دوره ی جدیدی تعریف نکرده اید ..."
      });
      this.$router.push({ name: "courseForm" });
    } else {
      this.getSections();
    }
  },
  methods: {
    async downloadFile(section, index, lecture, i) {
      try {
        let body = {
          course: parseInt(this.hasCourse().id),
          lecture: lecture.id,
          section: section.section_id
        };
        let { data } = await axios.post("/course-files/get", body);
        if (data.state !== 200) return;
        let fileName = data.file[0].attachedFile.split(".");
        this.download(
          `${lecture.lecture_name}.${fileName[fileName.length - 1]}`,
          this.appUrl.media + "/" + data.file[0].attachedFile
        );
      } catch (error) {
        console.log(error);
      }
    },
    download(filename, text) {
      window.open(text, "_blank");
    },
    async downloadVideo(item, index) {
      try {
        let { data } = await axios.post("/lecture/get-video-lecture-for-dl", {
          id: item.id
        });
        if (data.state != 200) return;
        let fileName = data.video.split(".");
        this.download(
          `${item.lecture_name}.${fileName[fileName.length - 1]}`,
          this.appUrl.media + "/" + data.video
        );
      } catch (error) {
        console.log(error);
      }
    },
    async getPlaye(section, index, lecture, i) {
      // try {
      //   // http://dev.madya.ir:8081/get-video-lecture
      //   let { data } = await axios.post('/lecture/get-video-lecture', { id: lecture.id })
      //   if (data.state != 200) return
      //   if (data.enc) {
      //     this.playVideoEnc(data.video)
      //   } else {
      //     this.playVideo(data.video)
      //   }

      // } catch (error) {
      //   console.log(error)
      // }
      try {
        let data = await this.$store.dispatch("courses/getVideo", {
          id: lecture.id
        });
        if (data.enc) {
          await this.playVideoEnc(data.video);
        } else {
          this.playVideo(data.video);
        }
      } catch (error) {
        console.log(error);
      }
    },
    nextStep() {
      this.$router.push("/dashboard/goals");
    },
    async gteFile(section, index, lecture, i) {
      try {
        let body = {
          course: this.hasCourse().id,
          lecture: lecture,
          section: section
        };

        let { data } = await axios.post("/course-files/get", body);
        if (data.state !== 200) return;
        this.$set(this.forms[index].lectures[i], "linkFile", data.file[0]);
        this.$set(this.forms[index].lectures[i], "attachedFile", data.file[0]);
      } catch (error) {
        console.log(error);
      }
    },
    async uploadFile(e, section, index, lecture, i) {
      var files = e.target.files[0];
      if (!files) return;

      let filesize = (files.size / 1024 / 1024).toFixed(2); // MB
      if (filesize > 200) {
        this.$root.showWarnMsg({
          message: "حجم فایل نباید بیشتر از ۲۰۰ مگابایت باشد... "
        });
        return;
      }
      this.isLoading = true;
      try {
        let lectures = this.forms[index].lectures[i];
        lectures.attachedFile = files;
        this.forms[index].lectures.splice(i, lectures);
        this.bodyFile = {
          section: section.section_id || section.id,
          course: this.hasCourse().id,
          lecture: null,
          attachedFile: files
        };
        // this.$store.commit('notifications/success', { message: this.$t('message.request.done'), title: '' }, { root: true })
      } catch (error) {
        console.log(error);
      }
      this.isLoading = false;
    },
    async saveFile(id) {
      try {
        this.bodyFile.lecture = id;
        let body = { ...this.bodyFile };
        var formData = new FormData();
        for (const key in body) {
          formData.append(key, body[key]);
        }
        let { data } = await axios.post("/course-files/save", formData, {
          onUploadProgress: function(progressEvent) {
            this.uploadPercentageData = parseInt(
              Math.round((progressEvent.loaded * 100) / progressEvent.total)
            );
          }.bind(this)
        });
        this.uploadPercentageData = 0;
        return data;
      } catch (error) {
        console.log(error);
      }
    },
    async updateFile(e, section, index, lecture, i) {
      var files = e.target.files[0];
      let FileSize = (files.size / 1024 / 1024).toFixed(2); 
      if (FileSize > 300) {
        this.$root.showWarnMsg({
          message: "حجم فایل نباید بیشتر از 300 مگابایت باشد... "
        });
        return;
      }
      this.isLoading = true;
      try {
        let lectures = this.forms[index].lectures[i];
        lectures.attachedFile = files;
        this.forms[index].lectures.splice(i, lectures);
        let body = {
          attachedFile: files,
          attach_id: lecture.linkFile.id
        };
        var formData = new FormData();
        for (const key in body) {
          formData.append(key, body[key]);
        }

        let { data } = await axios.post("/course-files/update", formData, {
          onUploadProgress: function(progressEvent) {
            this.uploadPercentageData = parseInt(
              Math.round((progressEvent.loaded * 100) / progressEvent.total)
            );
          }.bind(this)
        });
        if (data.state != 200) return;
        this.uploadPercentageData = 0;
        this.$store.commit(
          "notifications/success",
          { message: this.$t("message.request.done"), title: "" },
          { root: true }
        );
        this.gteFile(section.section_id, index, lecture.id, i);
      } catch (error) {
        console.log(error);
      }
      this.isLoading = false;
    },
    async removeLecture(section, index, lecture, i) {
      this.isLoading = true;
      try {
        let { data } = await axios.post("/lecture/delete", {
          id: parseInt(lecture.id)
        });
        if (data.state != 200) return;
        this.$store.commit(
          "notifications/success",
          { message: this.$t("message.request.done"), title: "" },
          { root: true }
        );
        this.forms[index].lectures.splice(i, 1);
        if (this.forms[index].lectures.length > 0) {
          this.forms[index].lectures.forEach((e, i) => {
            e.lecture_num = i + 1;
          });
          this.lectureForm.lecture_num = this.forms[index].lectures.length;
          if (this.forms[index].lectures.length == 1) {
            this.lectureForm.lecture_num = 1;
          }
        } else {
          this.lectureForm.lecture_num = 0;
        }
        // this.showLects(section, index)
      } catch (error) {
        console.log(error);
      }
      this.isLoading = false;
    },
    async removeSection(section, index) {
      this.isLoading = true;
      try {
        let { data } = await axios.post("/section/delete", {
          section_id: parseInt(section.section_id)
        });
        if (data.state != 200) return;
        this.$store.commit(
          "notifications/success",
          { message: this.$t("message.request.done"), title: "" },
          { root: true }
        );
        this.forms.splice(index, 1);
        if (this.forms.length > 0) {
          this.forms.forEach((e, i) => {
            e.section_num = i + 1;
          });
          this.lectureForm.lecture_num = this.forms.length;
          if (this.forms.length == 1) {
            this.sectionInform.section_num = 0;
          }
        } else {
          this.sectionInform.section_num = 0;
        }
        // this.getSections()
      } catch (error) {
        console.log(error);
      }
      this.isLoading = false;
    },
    async getSections() {
      this.forms = [];
      this.sectionInform.section_num = 0;
      let res = await this.$store.dispatch("dashboardSections/getSections");
      if (res && res.length === 0) {
        this.addSections();
      } else {
        res.forEach(e => {
          e.lectures = [];
        });
        this.forms.push(...res);
        this.sectionInform.section_num = this.forms.length;
        setTimeout(() => {
          vm.expanded = this.forms.length - 1;
        }, 0.9);
      }
      this.isLoading = false;
    },
    // openManual () {
    //     this.forms
    //   this.expanded = index
    // },
    clearLects(section, index) {
      if (this.forms && this.forms[index].lectures.length) {
        this.$set(this.forms[index], "lectures", []);
        // if (!this.forms.slice(-1)[0].section_id) {
        //   // this.forms.splice(this.forms.slice(-1)[0], 1)
        //   // this.$delete(this.forms, this.forms.length - 1)
        // }
      }
      // TODO reactive isAdd clear
      // if (!this.isAdd && !this.forms[this.forms.length - 1].section_id) {
      //   let i = this.forms.length - 1
      //   this.$delete(this.forms, i)
      //   this.isAdd = true
      // }
      // this.isAdd = true
    },
    async showLects(item, index) {
      if (!item.section_id) {
        // this.$root.showWarnMsg({
        //   message: 'مشکلی پیش آمده است'
        // })
        return;
      }
      this.isLoading = true;
      let res = await this.$store.dispatch("dashboardSections/getLects", {
        id: item.section_id
      });
      if (res.length) {
        this.forms[index].lectures = [];
        this.lectureForm.lecture_num = res.length;
        res.forEach((e, i) => {
          e.linkFile = null;
          e.attachedFile = null;
          if (e.has_file) {
            this.gteFile(item.section_id, index, e.id, i);
          }
        });
        this.$set(this.forms[index], "lectures", res);
      }
      this.isLoading = false;
    },
    async saveSection(item, index,scope) {
      let result = await this.$validator.validateAll(scope);
      if (!result) {
        this.$root.showWarnMsg({
          message: "لطفا فرم را تکمیل کنید ... "
        });
        return;
      }
      
      this.isLoading = true;
      let res = await this.$store.dispatch(
        "dashboardSections/saveSection",
        item
      );
      this.isLoading = false;
      if (!res || !res.section_id) {
        this.$root.showWarnMsg({
          message: "خطا در درخواست" + res.state
        });
        return;
      }
      this.forms[index].id = res.section_id;
      this.forms[index].section_id = res.section_id;
      this.isLoading = false;
    },
    async updateSection(item, index) {
      let result = await this.$validator.validate();
      if (!result) {
        this.$root.showWarnMsg({
          message: "لطفا فرم را تکمیل کنید ... "
        });
        return;
      }
      await this.$store.dispatch("dashboardSections/updateSection", item);
    },
    async updateVideo(e, section, index, lecture, i) {
      try {
        var formData = new FormData();

        formData.append("lecture_video", e.target.files[0]);
        formData.append("lecture_id", lecture.id);
        let { data } = await axios.post(
          "/lecture/update-video-lecture",
          formData,
          {
            onUploadProgress: function(progressEvent) {
              this.uploadPercentageData = parseInt(
                Math.round((progressEvent.loaded * 100) / progressEvent.total)
              );
            }.bind(this)
          }
        );
        if (data.state !== 200) return;
        this.uploadPercentageData = 0;
        this.$store.commit("notifications/success", {
          message: this.$t("message.request.done"),
          title: ""
        });
      } catch (error) {
        console.log(error);
      }
    },
    uploadVideo(e, section, index, lecture, i) {
      this.isLoading = true;
      var files = e.target.files;
      let lectures = this.forms[index].lectures[i];
      lectures.lecture_video = files[0];
      this.forms[index].lectures.splice(i, lectures);
      this.isLoading = false;
    },
    async updatePart(section, index, lecture, i, scope) {
      let result = await this.$validator.validateAll(scope);
      if (!result) {
        this.$root.showWarnMsg({
          message: "لطفا فرم را تکمیل کنید ... "
        });
        return;
      }
      this.isLoading = true;
      await this.$store.dispatch(
        "dashboardSections/updatePart",
        {
          section: section,
          lecture: lecture
        },
        {
          onUploadProgress: function(progressEvent) {
            this.uploadPercentageData = parseInt(
              Math.round((progressEvent.loaded * 100) / progressEvent.total)
            );
          }.bind(this)
        }
      ); // data : formData
      this.isLoading = false;
      if (!this.forms[index].lectures[i].has_file) return;
      let { state } = await this.saveFile(lecture.id);
      if (state !== 200) {
        this.$root.showWarnMsg({
          message: "در آپلود فایل مشکل پیش آمده ..."
        });
        return;
      }
      this.uploadPercentageData = 0;
      this.gteFile(section.id, index, lecture.id, i);
    },
    async savePart(section, index, lecture, i) {
      let result = await this.$validator.validate();
      if (!result) {
        this.$root.showWarnMsg({
          message: "لطفا فرم را تکمیل کنید ... "
        });
        return;
      }
      this.isLoading = true;
      let res = await this.$store.dispatch("dashboardSections/savePart", {
        section: section,
        lecture: lecture
      }); // data : formData
      if (res.state !== 200) {
        this.$store.commit(
          "notifications/error",
          { message: this.$t("message.request.someProblem"), title: "" },
          { root: true }
        );
        this.isLoading = false;
        return;
      }
      this.$store.commit(
        "notifications/success",
        { message: this.$t("message.request.done"), title: "" },
        { root: true }
      );
      let lecId = res.lec_id;
      let lectures = this.forms[index].lectures[i];
      lectures.id = lecId;
      this.forms[index].lectures.splice(i, lectures);
      this.isLoading = false;
      if (!this.forms[index].lectures[i].has_file) return;
      let { state } = await this.saveFile(lecId);
      console.log(state);
      if (state && state !== 200) {
        this.$root.showWarnMsg({
          message: "در آپلود فایل مشکل پیش آمده ..."
        });
        return;
      }
      this.gteFile(section.section_id, index, lecture.id, i);
    },
    async addSections() {
      // let result = await this.$validator.validate()
      // if (!result && this.forms.length > 0) {
      //   this.$root.showWarnMsg({
      //     message: 'لطفا فرم را تکمیل کنید ... '
      //   })
      //   return
      // }
      // this.isAdd = true
      if (this.forms.length > 0 && !this.forms.slice(-1)[0].section_id) {
        this.$root.showWarnMsg({
          message: "لطفا  آخرین فرم را ثبت کنید ... "
        });
        return;
      }
      this.sectionInform.section_num += 1;
      if (this.forms.length > 0 && this.forms.slice(-1)[0]) {
        let { data } = await axios.post("/section/check-pre-sections", {
          course: parseInt(this.hasCourse().id),
          section_num: this.forms.slice(-1)[0].section_num
        });
        // console.log(data.pre_result)
        if (!data.pre_result) {
          this.$root.showWarnMsg({
            message: "لطفا  آخرین فرم را ثبت کنید ... "
          });
          return;
        }
        this.sectionInform.section_num =
          this.forms.slice(-1)[0].section_num + 1;
      }
      const formsections = { ...this.sectionInform };
      this.forms.push(formsections);
      this.forms.forEach(e => {
        e.lectures = [];
      });
      setTimeout(() => {
        vm.expanded = this.forms.length - 1;
      }, 0.4);
      window.scrollTo(0, 0);
    },
    async partOne(section, index) {
      let result = this.$validator.validate();
      if (!result) {
        this.$root.showWarnMsg({
          message: "لطفا فرم را تکمیل کنید ... "
        });
        return;
      }
      if (!this.forms[index].section_id) {
        this.$root.showWarnMsg({
          message: "لطفا  آخرین فرم را ثبت کنید ... "
        });
        return;
      }
      this.lectureForm.lecture_num = 1;
      this.lectureForm.section_id = this.forms[index].section_id;
      const partSection = { ...this.lectureForm };
      if (partSection.lecture_num === 1 && index === 0) {
        partSection.is_preview = true;
      }

      this.forms[index].lectures.push(partSection);
    },
    async newPart(section, index, lecture, i) {
      let result = this.$validator.validate();
      if (!result) {
        this.$root.showWarnMsg({
          message: "لطفا فرم را تکمیل کنید ... "
        });
        return;
      }
      if (!section.section_id) {
        this.$root.showWarnMsg({
          message: "لطفا  آخرین فرم را ثبت کنید ... "
        });
        return;
      }
      let { data } = await axios.post("/lecture/check-pre-lecture", {
        section_id: section.section_id,
        course: parseInt(this.hasCourse().id),
        lecture_num: lecture.lecture_num
      });
      if (!data.pre_lecture) {
        this.$root.showWarnMsg({
          message: "لطفا ابتدا  فصل را ثبت کنید ... "
        });
        return;
      }
      this.lectureForm.lecture_num = lecture.lecture_num + 1;
      this.lectureForm.section_id = section.section_id;
      const partSection = { ...this.lectureForm };
      this.forms[index].lectures.push(partSection);
    }
  }
};
</script>

<style lang="less">
@import (reference) "../../assets/css/variable.less";
.page-dashbord-sections {
  .box-clear;
  .card-header {
    cursor: pointer;
    color: #0a0a0a;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/dashboard/sections.vue